import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dueTime'
})
export class DueTimePipe implements PipeTransform {
  transform(dueDate: string, currentDate: Date = new Date()): string {
    if (!dueDate) return 'Invalid date';

    // Convert the string date format "YYYY-MM-DDTHHmmss" to a valid Date object
    const parseDate = (dateStr: string): Date => {
      const year = parseInt(dateStr.substring(0, 4), 10);
      const month = parseInt(dateStr.substring(5, 7), 10) - 1; // Months are 0-indexed
      const day = parseInt(dateStr.substring(8, 10), 10);
      const hours = parseInt(dateStr.substring(11, 13), 10);
      const minutes = parseInt(dateStr.substring(13, 15), 10);
      const seconds = parseInt(dateStr.substring(15, 17), 10);
      return new Date(year, month, day, hours, minutes, seconds);
    };

    const due = parseDate(dueDate);
    // const current = parseDate(currentDate);

    const diffMs = due.getTime() - currentDate.getTime();
    if (diffMs < 0) return;

    // Convert milliseconds to time units
    const oneHour = 1000 * 60 * 60;
    const oneDay = oneHour * 24;
    const oneWeek = oneDay * 7;

    const weeks = Math.floor(diffMs / oneWeek);
    const days = Math.floor((diffMs % oneWeek) / oneDay);
    const hours = Math.floor((diffMs % oneDay) / oneHour);

    let result = 'Due in ';
    if (weeks > 0) result += `${weeks}wk `;
    if (days > 0) result += `${days}d `;
    if (hours > 0) result += `${hours}hr`;

    return result.trim(); // Remove trailing spaces
  }
}
